module.exports = {
    title: 'Informations about cookies!',
    description: 'By clicking on "ACCEPT ALL", functional, performance, analytical and marketing cookies will be stored - we can thus enable you to use the website comfortably and measure the functionality of our website. You can easily adjust your preferences by clicking on Cookie settings.</a>',
    primary_btn: {
        text: 'ACCEPT ALL',
        role: 'accept_all'      //'accept_selected' or 'accept_all'
    },
    secondary_btn: {
        text: 'Preferences',
        role: 'settings'       //'settings' or 'accept_necessary'
    },
    revision_message: '<br><br> Dear user, terms and conditions have changed since the last time you visisted!'
}
